import React from 'react';
import Logo from '../ui/Logo';
import Icon from '../ui/Icon';
import { useLanguage } from '../../contexts/LanguageContext';
import './LoginPage.css';
import './MaintenancePage.css';

const CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;

/**
 * Page d'accueil pendant la maintenance : même carte que la connexion,
 * seuls le propriétaire et les Administrateurs Site peuvent se connecter.
 */
const MaintenancePage = () => {
    const { t } = useLanguage();
    const accessDenied = new URLSearchParams(window.location.search).get('maintenance') === '1';

    const handleLogin = () => {
        const scope = 'identify email guilds';
        window.location.href = `https://discord.com/oauth2/authorize?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${encodeURIComponent(scope)}`;
    };

    return (
        <main className="c2-page login-page">
            <section className="c2-card login-card maintenance-card c2-fade-up">
                <div className="maintenance-card__stripes" aria-hidden="true" />
                <Logo size={180} />
                <div className="login-card__titles">
                    <h1 className="login-card__title">LadderPVP</h1>
                </div>

                <div className="maintenance-card__info">
                    <span className="c2-badge c2-badge--purple"><span className="c2-diamond" />{t('maintenance.badge', 'Site en travaux')}</span>
                    <p>
                        {t('maintenance.text', 'Une nouvelle version du site arrive bientôt. Le bot Discord continue de fonctionner normalement.')}
                    </p>
                </div>

                {accessDenied && (
                    <p className="maintenance-card__notice" role="alert">
                        {t('maintenance.denied', 'Ton compte n\'a pas accès au site pendant les travaux.')}
                    </p>
                )}

                <button type="button" className="c2-btn c2-btn--primary c2-btn--lg c2-btn--block" onClick={handleLogin}>
                    <Icon name="login" size={20} />
                    {t('maintenance.login', 'Se connecter avec Discord')}
                </button>
                <p className="maintenance-card__hint">{t('maintenance.hint', 'Accès réservé à l\'équipe pendant les travaux.')}</p>
            </section>
        </main>
    );
};

export default MaintenancePage;
